import axios from "axios";

export const cancelRFP = async (
  { cancellationReason, chargesApply, agencyNote, withoutEmails, rfpId },
  token
) => {
  if (cancellationReason) {
    try {
      const response = await axios.post(
        `${window.API}/rfp/${rfpId}/cancel`,
        {
          cancellation_reason: cancellationReason,
          cancellation_charges_apply: chargesApply,
          cancellation_agency_note: agencyNote,
          without_emails: withoutEmails,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return { result: response.data };
    } catch (error) {
      return { error };
    }
  }
};

export const uncancelRFP = async (rfpId, token) => {
  try {
    const response = await axios.post(
      `${window.API}/rfp/${rfpId}/uncancel`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return { result: response.data };
  } catch (error) {
    return { error };
  }
};
